/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@mui/material";
import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { filterJobAtom } from "../../shared/globalStates";
import "../Filter/Filter.css";
import FilterDivisi from "./FilterDivisi";
import FilterKota from "./FilterKota";
import FilterLevel from "./FilterLevel";

function Filter({ open, setOpen, handleClose }) {
  const [filter, setFilter] = useRecoilState(filterJobAtom);

  const handleChange = (e) => {
    var updatedList = [...filter];
    if (e.target?.checked) {
      updatedList = [...filter, e.target.value];
    } else {
      updatedList.splice(filter.indexOf(e.target.value), 1);
    }
    setFilter(updatedList);
  };

  const useStyle = makeStyles({
    content: {
      justifyContent: "space-between",
    },
    root: {
      root: {
        borderRadius: "10px",
      },
      "&:before": {
        display: "none",
      },
      boxShadow: "none",
      borderRadius: "10px",
      "& .MuiAccordionSummary-root": {
        padding: "0 20px",
        boxShadow: "none",
        border: "none",
      },
      border: "none",
    },
    "& .MuiFormControlLabel-root": {
      width: "100%",
    },
  });

  const classes = useStyle();
  return (
    <React.Fragment>
      <Paper variant="outlined" sx={{ borderRadius: "10px" }}>
        <div
          className="header-filter d-flex justify-content-between"
          style={{ padding: "0 20px", borderBottom: "hidden" }}>
          <b className="text-primary-main" style={{ padding: "20px 0" }}>Filter Jobs</b>
          <div
            className="button-cancel bg-neutral-n2-hover text-center"
            style={{
              margin: "auto 0",
              borderRadius: "50px",
              cursor: "pointer",
            }}
            onClick={() => setOpen(false)}>
            <span className="material-icons m-auto"> close </span>
          </div>
        </div>
        <hr style={{ margin: "0" }} />

        <FilterDivisi classes={classes} handleChange={handleChange} filter={filter} />
        <FilterKota classes={classes} handleChange={handleChange} filter={filter} />
        <FilterLevel classes={classes} handleChange={handleChange} filter={filter} />
      </Paper>
    </React.Fragment>
  );
}

export default Filter;
